import React, { useState } from 'react';
import { Form } from 'react-final-form';

import PredictFormInner from './PredictFormInner';
import validate from '../../../../utils/validate';
import { predictMessageYopValidation } from './validation';

function PredictForm({ onPredictResponse, onGenerateAlternate }) {
  const [previousRequest, setPreviousRequest] = useState({});

  const predictFormInitialValues = {
    url: '',
    message: '',
    audienceId: '',
  };

  const handlePredictMessage = (values) => {
    const newRequest = {
      message: values.message,
      url: values.url,
      audienceId: values.audienceId,
    };

    setPreviousRequest(newRequest);

    onPredictResponse({ ...newRequest });
    onGenerateAlternate({ ...newRequest });
  };

  return (
    <Form
      initialValues={predictFormInitialValues}
      onSubmit={handlePredictMessage}
      subscription={{ submitting: true, pristine: true }}
      validateOnBlur={false}
      validate={(values) => validate(values, predictMessageYopValidation())}
      render={({ handleSubmit }) => <PredictFormInner onSubmit={handleSubmit} previousRequest={previousRequest} />}
    />
  );
}

export default PredictForm;
